<template>
  <FormModal :value="showModal">
    <div v-if="disabled">
      <h3>{{ $t('YEAR_CHECK.FORBIDDEN.TITLE') }}</h3>
      <p class="my-2">
        {{ $t('YEAR_CHECK.FORBIDDEN.SUBTITLE') }}
      </p>
    </div>
    <div v-else class="text-center" >
      <h3>{{ $t('YEAR_CHECK.TITLE') }}</h3>
      <p class="my-2">{{ $t('YEAR_CHECK.SUBTITLE') }}</p>

      <p class="mx-4">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              :label="$t('YEAR_CHECK.PLACEHOLDER')"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            ref="picker"
            :max="new Date().toISOString().substr(0, 10)"
            min="1920-01-01"
            @click:year="setYear"
          ></v-date-picker>
        </v-menu>
      </p>

      <p class="px-2">
        <BaseButton
          :disabled="!date"
          @click="check()"
        >
          {{ $t('YEAR_CHECK.CHECK') }}
        </BaseButton>
      </p>
    </div>
  </FormModal>
</template>

<style scoped>
>>>.v-picker__title {
  display: none;
}
</style>

<script>
import FormModal from '@/components/form/FormModal.vue';

const MIN_AGE = 14;

export default {
  name: 'YearModal',
  components: {
    FormModal,
  },
  data: () => ({
    date: null,
    menu: false,
    disabled: false,
  }),
  computed: {
    showModal() {
      // Is login or register?
      const nonModalViews = ['login', 'register', 'logout'];
      if (nonModalViews.indexOf(this.$route.name) > -1) {
        return false;
      }

      // Are you logged, and can play?
      const { isLogged } = this.$store.state.session;
      const { year } = this.$store.state.settings;
      if (isLogged && (!year || !this.canPlay(year))) {
        return true;
      }

      return false;
    },
  },
  methods: {
    setYear(date) {
      this.date = date;
      this.$refs.menu.save(date);
    },
    check() {
      if (!this.canPlay(this.date)) {
        this.disabled = true;
        return false;
      }

      this.$store.dispatch('settings/store', { year: this.date });
      return true;
    },
    canPlay(date) {
      const year = new Date().getFullYear();
      if (year - date < MIN_AGE) {
        return false;
      }
      return true;
    },
  },
  watch: {
    menu(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.picker.activePicker = 'YEAR';
        });
      }
    },
  },
};
</script>
